import { useState, useEffect } from 'react';
import { useAuthFetch } from '@/hooks/useAdmin';
import { Mail, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const authFetch = useAuthFetch();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  async function load() {
    try { const r = await authFetch(`${API}/admin/newsletter-subscribers`); if (r.ok) { const d = await r.json(); setItems(d.subscribers || []); setTotal(d.total || 0); } }
    catch (e) { console.error(e); } finally { setLoading(false); }
  }

  if (loading) return <div className="flex items-center justify-center h-full"><Loader2 className="animate-spin text-zinc-500" /></div>;

  return (
    <div className="p-6 max-w-4xl" data-testid="newsletter-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold">Newsletter pretplatnici</h1>
        <span className="text-sm text-zinc-500">Ukupno: {total}</span>
      </div>
      {items.length === 0 ? (
        <div className="text-center py-12 text-zinc-500">Nema pretplatnika</div>
      ) : (
        <div className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-zinc-800 text-zinc-500 text-left">
              <th className="px-4 py-3 font-medium">E-mail</th>
              <th className="px-4 py-3 font-medium">Jezik</th>
              <th className="px-4 py-3 font-medium">Datum</th>
              <th className="px-4 py-3 font-medium">Status</th>
            </tr></thead>
            <tbody>
              {items.map((s, i) => (
                <tr key={i} className="border-b border-zinc-800/50">
                  <td className="px-4 py-3 text-zinc-200">{s.email}</td>
                  <td className="px-4 py-3 text-zinc-400 uppercase text-xs">{s.locale}</td>
                  <td className="px-4 py-3 text-zinc-400 text-xs">{new Date(s.subscribed_at).toLocaleDateString('hr')}</td>
                  <td className="px-4 py-3"><span className="text-xs px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-400">{s.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
